module.exports = __webpack_public_path__ + "img/kong.721b19fe.png";